"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFreeText = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var react_1 = require("react");
var react_hook_form_1 = require("react-hook-form");
var react_router_dom_1 = require("react-router-dom");
var base_1 = require("@apis/base");
var freeText_1 = require("@apis/freeText");
var pushFreeText_1 = require("@apis/pushFreeText");
var channel_1 = require("@domain/channel");
var freeText_2 = require("@domain/freeText");
var liff_1 = require("@domain/liff");
var useError_1 = require("@store/freeText/useError");
var useEnqueueSnackbar_1 = require("@store/useEnqueueSnackbar");
require("rsuite/dist/rsuite.min.css");
var useFreeText = function () {
    var enqueueSnackbar = (0, useEnqueueSnackbar_1.useEnqueueSnackbar)();
    var search = (0, react_router_dom_1.useLocation)().search;
    var _a = (0, react_1.useState)(false), isLoading = _a[0], setIsLoading = _a[1];
    var _b = (0, useError_1.useError)(), isError = _b.isError, setIsError = _b.setIsError;
    var query = (0, react_1.useMemo)(function () { return new URLSearchParams(search); }, [search]);
    var contentId = Number(query.get("content_id"));
    var scenarioId = Number(query.get("scenario_id"));
    var _c = (0, react_1.useState)([]), scenarioContentItems = _c[0], setScenarioContentItems = _c[1];
    var _d = (0, react_hook_form_1.useForm)({
        mode: "onChange",
    }), control = _d.control, handleSubmit = _d.handleSubmit, _e = _d.formState, errors = _e.errors, isValid = _e.isValid, reset = _d.reset, watch = _d.watch;
    var watchAllFields = watch();
    (0, react_1.useEffect)(function () {
        var defaultValues = scenarioContentItems.reduce(function (defaultMap, item) {
            defaultMap[item.id.toString()] = "";
            return defaultMap;
        }, {});
        reset(defaultValues);
    }, [scenarioContentItems, reset]);
    (0, react_1.useEffect)(function () {
        var channelId = (0, channel_1.getChannelId)();
        var liffId = (0, liff_1.getLiffId)();
        if (channelId === null || liffId === null || contentId === null) {
            return;
        }
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, liff_1.initFreeTextLiff)(liffId, channelId, contentId, scenarioId, setIsError)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); })();
        getFreeTextContent(channelId, Number(contentId));
        // eslint-disable-next-line react-hooks/exhaustive-deps -- 暫定対応
    }, []);
    var getFreeTextContent = function (channelId, contentId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, freeText;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, freeText_1.getScenarioContent)(channelId, contentId)];
                case 1:
                    response = _a.sent();
                    if (response.status === 200) {
                        freeText = response.freeText;
                        setScenarioContentItems(freeText.scenarioContentItems);
                        setIsLoading(false);
                        return [2 /*return*/];
                    }
                    (0, base_1.handleError)(response, enqueueSnackbar);
                    return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var channelId, answerItemList, freeTextItemAnswer, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    channelId = (0, channel_1.getChannelId)();
                    answerItemList = (0, freeText_2.getAnswerItems)(scenarioContentItems, data);
                    freeTextItemAnswer = {
                        scenarioId: scenarioId,
                        contentId: contentId,
                        answers: answerItemList,
                    };
                    if (channelId === null) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, (0, pushFreeText_1.pushFreeText)(channelId, freeTextItemAnswer, setIsError)];
                case 1:
                    res = _a.sent();
                    setIsLoading(false);
                    if (res.status === 500) {
                        setIsError(true);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getLabel = function (isRequired, itemTitle) {
        if (isRequired) {
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [itemTitle, " ", (0, jsx_runtime_1.jsx)(Typography_1.default, { component: "span", fontSize: "10px", color: "#ff0000", children: "*" })] }));
        }
        return itemTitle;
    };
    return {
        isLoading: isLoading,
        scenarioContentItems: scenarioContentItems,
        control: control,
        handleSubmit: handleSubmit,
        errors: errors,
        isValid: isValid,
        watchAllFields: watchAllFields,
        onSubmit: onSubmit,
        getLabel: getLabel,
        isError: isError,
    };
};
exports.useFreeText = useFreeText;
